/**
 * Edit Instructor Review Route
 * Route: /instructors/:instructorId/reviews/:reviewId/edit
 *
 * The form UI lives in the .lazy.tsx file; nothing SSR-relevant remains here.
 * See the studio counterpart for why the session guard lives on the route.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

export const Route = createFileRoute('/_public/instructors/$instructorId/reviews/$reviewId/edit')({
  // Form-shaped pending while the lazy chunk downloads; title matches the page
  // the route becomes (aria-labelled, kept out of the visual tree as a block).
  pendingComponent: () => <FormPageTemplatePending title="Edit your review" cta />,
  beforeLoad: ({ context, location }) => {
    if (context.authState === 'unauthenticated') {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
});
